import { openDialog, closeDialog } from 'src/redux/slices/alertDialog'
import {
  setExaminerDetail,
  setExamEmailError,
  setExamEmailLoading,
} from 'src/redux/slices/eExamination'
import { callChangeEmail, callRequestEmailOTP } from 'src/services/myProfile'
import _ from 'lodash'

// เปลี่ยนอีเมล
export const changeExamEmail = (params) => async (dispatch, getState) => {
  try {
    dispatch(setExamEmailLoading(true))

    const response = await dispatch(callChangeEmail(params))
    const payload = _.get(response, 'payload', '')

    if (payload?.data?.status === 'SUCCESS') {
      // หา index ของ examiner จาก uuid
      const state = getState()
      const index = state.eExamination.examiners.findIndex(
        (e) => e.uuid === params.uuid
      )

      // บันทึกอีเมลใหม่เข้า state
      if (index !== -1) {
        dispatch(
          setExaminerDetail({
            index,
            obj: 'email',
            value: payload.data.result.newEmail,
          })
        )
      }

      dispatch(
        openDialog({
          isCloseDialog: false,
          iconType: 'success',
          title: 'สำเร็จ',
          message: ['เปลี่ยนอีเมลสำเร็จแล้ว'],
          buttonRight: {
            label: 'ตกลง',
            handleClick: () => {
              dispatch(closeDialog())
            },
          },
        })
      )
    } else {
      const message = payload?.data?.message || 'ไม่สามารถเปลี่ยนอีเมลได้'

      dispatch(
        openDialog({
          isCloseDialog: false,
          iconType: 'error',
          title: 'เกิดข้อผิดพลาด',
          message: [message],
          buttonRight: {
            label: 'ตกลง',
            handleClick: () => {
              dispatch(closeDialog())
            },
          },
        })
      )
      dispatch(
        setExamEmailError({
          path: 'otp',
          message,
        })
      )
    }
  } catch (err) {
    dispatch(
      openDialog({
        isCloseDialog: false,
        iconType: 'error',
        title: 'เกิดข้อผิดพลาด',
        message: [err?.message || 'ไม่สามารถเปลี่ยนอีเมลได้'],
        buttonRight: {
          label: 'ตกลง',
          handleClick: () => {
            dispatch(closeDialog())
          },
        },
      })
    )
  } finally {
    dispatch(setExamEmailLoading(false))
  }
}

// ขอ OTP
export const requestExamOtp = (params) => async (dispatch) => {
  try {
    const response = await dispatch(callRequestEmailOTP(params))
    const payload = _.get(response, 'payload', '')

    if (payload?.data?.errorCase) {
      dispatch(
        openDialog({
          isCloseDialog: false,
          iconType: 'error',
          title: payload?.data?.title || 'เกิดข้อผิดพลาด',
          message: [payload?.data?.message || 'ไม่สามารถส่งรหัส OTP ได้'],
          buttonRight: {
            label: 'ตกลง',
            handleClick: () => {
              dispatch(closeDialog())
            },
          },
        })
      )
    }

    return payload
  } catch (err) {
    dispatch(
      openDialog({
        isCloseDialog: false,
        iconType: 'error',
        title: 'เกิดข้อผิดพลาด',
        message: [err?.message || 'ไม่สามารถส่งรหัส OTP ได้'],
        buttonRight: {
          label: 'ตกลง',
          handleClick: () => {
            dispatch(closeDialog())
          },
        },
      })
    )
    return { status: 'FAILED' }
  }
}
